import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createReducer } from '@reduxjs/toolkit';
import { TARIFF_GROUP, currentStateList } from "../constants";
import { resetColoredTariffsData, setColoredTariffsData, setTariffsGroup } from "./actions";
import { setCurrentPopupState, setIsLoadingTariffButton } from "./asyncActions";
var initialState = {
  coloredNotificationData: null,
  coloredTariffsData: null,
  currentPopupState: currentStateList.none,
  group: TARIFF_GROUP.homeInternet,
  tariffButtonLoading: {
    inacId: null,
    isLoad: false
  }
};
export var tariffsReducer = createReducer(initialState, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, resetColoredTariffsData.type, function (state) {
  state.coloredTariffsData = null;
  state.coloredNotificationData = null;
}), setColoredTariffsData.type, function (state, _ref) {
  var _payload$content;
  var payload = _ref.payload;
  state.coloredTariffsData = payload;
  state.coloredNotificationData = (_payload$content = payload.content) === null || _payload$content === void 0 ? void 0 : _payload$content.notificationText;
}), setCurrentPopupState.type, function (state, action) {
  state.currentPopupState = action.payload;
}), setIsLoadingTariffButton.type, function (state, action) {
  state.tariffButtonLoading = action.payload;
}), setTariffsGroup.type, function (state, action) {
  state.group = action.payload;
}));